module.exports = __webpack_public_path__ + "static/img/edge.b3485d61.png";